import { render, staticRenderFns } from "./InventoryItemList.vue?vue&type=template&id=2acdd84d&scoped=true&"
import script from "./InventoryItemList.vue?vue&type=script&lang=js&"
export * from "./InventoryItemList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemList.vue?vue&type=style&index=0&id=2acdd84d&prod&lang=scss&scoped=true&"
import style1 from "./InventoryItemList.vue?vue&type=style&index=1&id=2acdd84d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdd84d",
  null
  
)

export default component.exports